import type { CoinbaseEngUsersAccountManagementApiApiAddress } from '@cbhq/identity-api-hooks/account-management/types';

export const ROUTE_TEAM = '/team';

export function getTeamMemberRoute(userUuid: string) {
  return `${ROUTE_TEAM}/member/${userUuid}`;
}

// MemberRole is now a string type to support dynamic roles from the backend.
// Role IDs follow the format: {product_id}/legal_entity:{role_id}
// It would nice to improve type safety here.
export type MemberRole = string;

export type MemberRoleMap = {
  label: string;
  name: string;
  description: string;
  value: MemberRole;
  productKey: string;
};

export type Member = {
  userUuid: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: MemberRole[];
  avatarUrl?: string;
  address?: CoinbaseEngUsersAccountManagementApiApiAddress;
};
